import { readFile } from './utils'
import styles from './FileInput.css'
import { Text } from '@vtex/admin-ui'
import { useRef } from 'react'

interface Props
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onChange' | 'onError'> {
  children: React.ReactNode
  onChange: (file: string) => void
  onError?: (err: Error) => void
  helpText?: string
}

export function FileInput({
  children,
  onChange,
  helpText,
  onError = () => {},
  ...props
}: Props) {
  const inputRef = useRef<HTMLInputElement>(null)

  const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    try {
      if (!e.target.files) {
        onError(new Error('No file detected'))
        return
      }
      readFile(e.target.files[0]).then((data) => {
        onChange(data)
      })
    } catch (err) {
      if (err instanceof Error) {
        onError(err)
      }
    }
  }

  const openInput = () => {
    if (inputRef.current) {
      inputRef.current.value = ''
      inputRef.current?.click()
    }
  }

  return (
    <>
      <div onClick={openInput}>{children}</div>
      <input
        id={props.id}
        data-testid={props.id}
        type="file"
        hidden
        onChange={handleChange}
        accept=".csv,.txt"
        ref={inputRef}
      />
      <Text className={styles.helpText} variant="detail" tone="secondary">
        {helpText}
      </Text>
    </>
  )
}
